export const genericCatalogId = 1

// Id of Standard-Preisplan
export const defaultPricePlanId = 1

// Id of Standardpreise
export const defaultCustomerGroupId = 43
